<template>
	<div>
		<div class="wrapper">
			<!-- 서브 헤더 --------- start -->
			<v-layout wrap class="mb-2" align-center>
				<v-icon color="#9D9DB7">
					mdi-circle-small
				</v-icon>
				<span class="sub_header">마케터 관리</span>
			</v-layout>
			<!-- 서브 헤더 ----------- end -->

			<v-layout align-center class="header_search">
				<v-layout class="search_wrap">
					<v-layout style="max-width: 18.88401833492636% !important">
						<v-flex class="search_select_type ml-4" style="width:calc(75.06192608902344% - 16px) !important; max-width:300px;">
							<selectBox :sel="marketerCategory" :class="'searchSel'" @change="changeMarketer()"></selectBox>
						</v-flex>
					</v-layout>

					<v-layout justify-end style="max-width: 79.11598166507364% !important;">
						<v-flex class="search_select ml-3" style="width:calc(12.674361008455392% - 12px) !important; max-width:120px !important;">
							<selectBox :sel="approveSel" :class="'searchSel'" @change="changeApproval()"></selectBox>
						</v-flex>

						<!-- 영업팀 선택 --------- start -->
						<v-flex class="search_select ml-3" style="width:calc(12.674361008455392% - 12px) !important; max-width:120px !important;">
							<selectBox :sel="bigTeamSel" :class="'searchSel'" @change="clickGlSel()"></selectBox>
						</v-flex>
						<v-flex class="search_select ml-3" style="width:calc(12.674361008455392% - 12px) !important; max-width:120px !important;">
							<selectBox :sel="mediumTeamSel" :class="'searchSel'" @change="clickHqSel()"></selectBox>
						</v-flex>
						<v-flex class="search_select ml-3" style="width:calc(12.674361008455392% - 12px)!important; max-width:120px !important;">
							<selectBox :sel="smallTeamSel" :class="'searchSel'" @change="clickTeamSel()"></selectBox>
						</v-flex>
						<v-flex class="search_select ml-3" style="width:calc(12.674361008455392% - 12px) !important; max-width:120px !important;">
							<selectBox :sel="authoritySel" :class="'searchSel'" @change="clickAuthoritySel()"></selectBox>
						</v-flex>
						<v-flex class="search_select ml-3" style="width:calc(12.674361008455392% - 12px) !important; max-width:120px!important;">
							<selectBox :sel="namePhoneSel" :class="'searchSel'"></selectBox>
						</v-flex>
						<!-- 영업팀 선택 --------- end -->

						<!-- 이름/연락처 검색 start  -->
						<v-flex md3 sm3 xs12>
							<txtField
								class="search_box_type"
								v-model="search_project_input"
								:txtField="search"
								@keyup.enter="handleEnterKey"
								ref="search_input"
							></txtField>
						</v-flex>

						<v-btn
							class="search_btn"
							color="#ff9419"
							@click="
								() => {
									first = false
									searchType = 'text'
									this.search_project = this.search_project_input
									getTableData()
								}
							"
							><v-icon>mdi-magnify</v-icon>조회</v-btn
						>
						<!-- 이름 검색 end  -->
					</v-layout>
				</v-layout>
			</v-layout>

			<!-- --- 데이터 테이블 -------- start -->
			<v-layout wrap>
				<!-- 테이블 -->
				<v-flex xs12>
					<datatable
						:marketingAllCheck="marketingAllCheck"
						:search="search_project"
						:datatable="table.datatable"
						class="tbl-type01 table_td_smallPadding"
						:detailClick="detailClick"
						excelUseYn="true"
						excelType="marketing_marketer"
						@pagination="pagination"
						:getExcelData="getExcelData"
						@approveIndividual="approveIndividual"
						excelTextYn="true"
						excelRoute="marketingMarketer"
					>
					</datatable>
				</v-flex>
			</v-layout>
			<!-- --- 데이터 테이블 -------- end -->
		</div>

		<v-layout justify-start align-items-center class="left_minus_margin">
			<btn
				:btn="addBtn"
				:class="'small_action_btn'"
				:style="`background-color:${$store.state.PointColor2}`"
				:btn_txt="'마케터 그룹 관리'"
				@click="openGropManage()"
			></btn>
			<btn
				:btn="addBtn"
				:class="'ml-2 small_action_btn'"
				:style="`background-color:${$store.state.PointColor2}`"
				:btn_txt="'일괄승인'"
				@click="clickAllapproval('approve')"
			></btn>
			<btn
				:btn="addBtn"
				:class="'ml-2 small_action_btn'"
				:style="`background-color:${$store.state.PointColor2}`"
				:btn_txt="'일괄미승인'"
				@click="clickAllapproval('disApprove')"
			></btn>
		</v-layout>

		<!-- 마케터 아이템 자세히보기 dialog -->
		<editMarketingMarkerDialog :data_id="this.clicked_data.id" :detail_data="clicked_data" :setdialog="marketerManage_dialog" />
		<!-- 마케터 그룹 관리 dialog -->
		<editMarketingGropDialog :setdialog="marketerGroup_dialog" :businessId="String(this.businessId)" />
		<!-- 마케터 일괄 승인 dialog -->
		<sweetAlert :dialog="sweet_allApprove" @click="approveAll()" />
		<!-- 마케터 일괄 미승인 dialog -->
		<sweetAlert :dialog="sweet_allDisApprove" @click="disApproveAll()" />
		<!-- 마케터 개인 미승인 dialog -->
		<sweetAlert :dialog="sweet_unapproved" @click="unapproveIndividual()" class="below_loading" />
		<!-- 승인/미승인 처리 결과 dialog -->
		<sweetAlert :dialog="sweetDialog" />
	</div>
</template>

<script>
import { datatable, selectBox, txtField, btn, sweetAlert } from '@/components/index.js'
import editMarketingGropDialog from '@/components/dialog/editMarketingGropDialog.vue'
import editMarketingMarkerDialog from '@/components/dialog/editMarketingMarkerDialog.vue'
export default {
	components: {
		datatable,
		selectBox,
		txtField,
		btn,
		sweetAlert,
		editMarketingGropDialog,
		editMarketingMarkerDialog,
	},

	data() {
		return {
			gl: [],
			hq: [],
			team: [],

			clicked_data: {},
			tableData: [],
			businessId: '',
			blocked_count: '',
			approval_count: '',

			marketerCategory: {
				value: '',
				errorMessage: '',
				hideDetail: true,
				items: [],
				fullItem: [],
				outlined: true,
				filter: true,
				label: '',
				returnObject: true,
				itemText: 'title',
			},
			// 기본 테이블
			table: {
				datatable: {
					headers: [
						{ text: '마케팅체크박스', value: 'marketingCheck', width: '5%', sortable: false, checked: false },
						{ text: 'No.', value: 'index', width: '5%', sortable: false },
						{ text: '총괄', value: 'glTitle', width: 'auto', sortable: false },
						{ text: '본부', value: 'hqTitle', width: 'auto', sortable: false },
						{ text: '팀', value: 'teamTitle', width: 'auto', sortable: false },
						{ text: '이름', value: 'name', width: '6%', sortable: false },
						{ text: '권한', value: 'role', width: '6%', sortable: false },
						{ text: '연락처', value: 'phone', width: 'auto', sortable: false },
						{ text: '등록일', value: 'created_at_time', width: 'auto', sortable: false },
						{ text: '승인일', value: 'approvalDate', width: 'auto', sortable: false },
						{ text: '최근접속일', value: 'recentLogin', width: 'auto', sortable: false },
						{ text: '배분수량', value: 'distribution', width: '5%', sortable: false },
						{ text: '처리', value: 'processed', width: '5%', sortable: false },
						{ text: '미처리', value: 'unprocessesd', width: '5%', sortable: false },
						{ text: '승인', value: 'approval', width: '5%', sortable: false },
						{ text: '비고', value: 'etc_detail', width: '110px', sortable: false },
					],
					items: [],
					hidedefaultfooter: false,
					noweditting: '',
					onlyAgree: false,
					page: 1,
					itemsPerPage: 10,
					total: 0,
					selected_user: [],
					pagination: {
						start: 0,
						page: 1,
						itemsPerPage: 10,
					},
				},
				filter: [],
				json_fields: {},
			},

			// 날짜/검색 데이터
			searchsel: {
				value: '',
				errorMessage: '',
				hideDetail: true,
				items: [],
				outlined: true,
			},
			// 승인/미승인 필터
			approveSel: {
				value: 'all',
				errorMessage: '',
				hideDetail: true,
				items: [
					{ value: 'all', text: '전체' },
					{ value: false, text: '승인' },
					{ value: true, text: '미승인' },
				],
				outlined: true,
				itemText: 'text',
			},
			// 영업팀 데이터
			bigTeamSel: {
				value: '전체',
				errorMessage: '',
				hideDetail: true,
				items: [{ text: '', value: {} }],
				outlined: true,
				itemText: 'text',
			},
			mediumTeamSel: {
				value: '전체',
				errorMessage: '',
				hideDetail: true,
				items: [],
				outlined: true,
				itemText: 'text',
			},
			smallTeamSel: {
				value: '전체',
				errorMessage: '',
				hideDetail: true,
				items: [],
				outlined: true,
				itemText: 'text',
			},
			// 권한 데이터
			authoritySel: {
				value: 'all',
				errorMessage: '',
				hideDetail: true,
				items: [
					{ text: '전체', value: 'all' },
					{ text: '총괄', value: 'GeneralManager' },
					{ text: '본부', value: 'HeadquarterManager' },
					{ text: '팀장', value: 'TeamLeader' },
					{ text: '상담사', value: 'Counselor' },
				],
				outlined: true,
				itemText: 'text',
			},
			// 이름,연락처 데이터
			namePhoneSel: {
				value: '이름',
				errorMessage: '',
				hideDetail: true,
				items: ['이름', '연락처'],
				outlined: true,
			},

			searchsel_type: {
				value: '이름',
				errorMessage: '',
				hideDetail: true,
				items: ['이름', '연락처'],
				outlined: true,
			},

			search_project_input: '',
			search_project: '',
			search: {
				placeholder: '검색어를 입력해주세요.',
				maxlength: '255',
				outlined: true,
				backCol: 'white',
			},
			// 마케터 자세히보기 다이어로그
			marketerManage_dialog: {
				dialog: false,
			},
			// 마케터 그룹 다이어로그
			marketerGroup_dialog: {
				dialog: false,
			},

			addBtn: {
				// 추가 버튼
				dark: true,
			},

			filter: [],

			searchPhone: '',
			searchName: '',
			searchBtn: {
				class: '',
				dark: true,
				color: this.$store.state.PointColor2,
				height: 40,
			},
			excelArr: [],

			searchType: '', // range - 기간 검색, text - 이름/전화번호 검색

			sweet_allApprove: {
				// 마케터 일괄 승인 dialog
				open: false,
				title: '일괄승인',
				content: `체크된 미승인 마케터를 일괄 승인 하시겠습니까?`,
				cancelBtnText: '취소',
				buttonType: 'twoBtn',
				saveBtnText: '확인',
				modalIcon: 'success',
			},
			sweet_allDisApprove: {
				// 마케터 일괄 미승인 dialog
				open: false,
				title: '일괄미승인',
				content: `체크된 승인 마케터를 일괄 미승인 하시겠습니까?`,
				cancelBtnText: '취소',
				buttonType: 'twoBtn',
				saveBtnText: '확인',
				modalIcon: 'success',
			},
			sweet_unapproved: {
				// 마케터 개인 미승인 dialog
				open: false,
				title: '미승인 처리',
				content: ``,
				cancelBtnText: '취소',
				buttonType: 'twoBtn',
				saveBtnText: '확인',
				modalIcon: 'success',
				item: {},
				closeFunction: this.unapproveIndividualCancel,
			},
			sweetDialog: {
				//  승인/미승인 처리 결과 dialog
				open: false,
				title: '',
				content: ``,
				modalIcon: '',
				cancelBtnText: '확인',
				buttonType: 'oneBtn',
			},
		}
	},
	created() {
		this.getMarketerList()
	},
	props: {
		nowTabs: Number,
		tabIdx: Number,
	},
	watch: {
		edit_dialog: {
			deep: true,
			handler() {
				// 값 다시 불러오기
				this.getGroupList('gl')
				this.getGroupList('hq')
				this.getGroupList('team')
			},
		},
		// nowTabs: {
		// 	deep: true,
		// 	async handler() {
		// 		if (this.nowTabs === this.tabIdx) {
		// 			await this.getTableData()
		// 		}
		// 	},
		// },
	},
	methods: {
		/**검색란 엔터키 핸들러
		@author 임호진
		*/
		handleEnterKey() {
			this.first = false
			this.searchType = 'text'
			this.search_project = this.search_project_input
			this.getTableData()
		},
		/**총괄 셀렉터 클릭 핸들러
		@author 임호진
		*/
		clickGlSel() {
			this.initSearch()
			this.getHqList()
		},
		/**본부 셀렉터 클릭 핸들러
		@author 임호진
		*/
		clickHqSel() {
			this.initSearch()
			this.getTeamList()
		},

		/**팀 셀렉터 클릭 핸들러
		@author 임호진
		*/
		clickTeamSel() {
			this.initSearch()
			this.getTableData()
		},
		/**권한 셀렉터 클릭 핸들러
		@author 임호진
		*/
		clickAuthoritySel() {
			this.initSearch()
			this.getTableData()
		},

		getHqList() {
			this.getGroupList('hq')
			this.mediumTeamSel.value = ''
			this.mediumTeamSel.items = []
			this.smallTeamSel.value = ''
			this.smallTeamSel.items = []
		},
		getTeamList() {
			this.getGroupList('team')
			this.smallTeamSel.items = []
		},

		/**리스트 가져오기- 타입별
		@param {String} type gl,hq,team
		@param {Boolean} selChange 마케터 그룹 관리에서 변경 있을 시 true -> getTableData 미실행
		@author 임호진
		*/
		async getGroupList(type, selChange = true) {
			let query = ''
			let data = {}

			// 1. 타입별 쿼리와 파라미터 값을 정한다.
			if (type === 'gl') {
				query = 'generals'
				data = {
					businessId: String(this.businessId),
				}
			} else if (type === 'hq') {
				query = 'headquarters'
				data = {
					businessId: String(this.businessId),
					glId: String(this.bigTeamSel.value.id),
				}
			} else if (type === 'team') {
				query = 'teams'
				data = {
					businessId: String(this.businessId),
					glId: String(this.bigTeamSel.value.id),
					hqId: String(this.mediumTeamSel.value.id),
				}
			} else {
				query = ''
				return
			}

			if (selChange) {
				// 셀렉트 박스 change시에만 로딩 처리
				this.$store.state.loading = true
			}

			// 2. 정해진 값으로 데이터를 불러온다.
			await this.$store.dispatch(query, data).then(res => {
				const data = res.data[query]

				if (Array.isArray(data) && data.length > 0) {
					let new_arr = []

					for (let i = 0; i < data.length; i++) {
						let form = {
							text: data[i].title,
							value: data[i],
						}
						new_arr.push(form)
					}
					if (type === 'gl') {
						this.bigTeamSel.items = new_arr
					} else if (type === 'hq') {
						this.mediumTeamSel.items = new_arr
						this.mediumTeamSel.items.unshift('전체')

						if (selChange) {
							// 셀렉트 박스 change시에만 value 변경
							this.mediumTeamSel.value = '전체'
						}
					} else if (type === 'team') {
						this.smallTeamSel.items = new_arr
						this.smallTeamSel.items.unshift('전체')

						if (selChange) {
							// 셀렉트 박스 change시에만 value 변경
							this.smallTeamSel.value = '전체'
						}
					}
				} else {
					if (type === 'gl') {
						this.bigTeamSel.items = [{ text: '', value: {} }]
					} else if (type === 'hq') {
						this.mediumTeamSel.items = []
					} else if (type === 'team') {
						this.smallTeamSel.items = []
					}
				}

				if (selChange) {
					// 셀렉트 박스 change시에만 로딩 처리
					this.$store.state.loading = false
				}
			})

			const allCategory = {
				text: '전체',
				value: {},
			}
			if (this.bigTeamSel.items[0].text !== '전체') {
				this.bigTeamSel.items.unshift(allCategory)
				if (selChange) {
					// 셀렉트 박스 change시에만 value 변경
					this.bigTeamSel.value = allCategory
				}
				if (this.bigTeamSel.items[1].text == '') this.bigTeamSel.items.pop()
			}

			if (selChange) {
				// 셀렉트 박스 change시에만 테이블 데이터 호출
				this.getTableData()
			}
		},
		/**검색란 초기화
		@author 임호진
		*/
		initSearch() {
			this.search_project = ''
			this.search_project_input = ''
		},

		/**비즈니스 모델 변경 값 갱신
		@author 임호진
		*/
		async changeMarketer() {
			this.initSearch()

			this.businessId = this.marketerCategory.value.id

			// 값 초기화
			this.bigTeamSel.value = ''
			this.mediumTeamSel.value = ''
			this.smallTeamSel.value = ''
			this.approveSel.value = 'all'
			this.authoritySel.value = 'all'
			this.search_project_input = ''
			this.getGroupList('gl')
		},

		/**테이블 데이터 적용
		@author 임호진
		*/
		async getTableData(range = {}) {
			this.$store.state.loading = true

			// 조건 필터
			const filtered = {
				_start: range.start ? range.start : 0,
				_limit: range.limit ? range.limit : 10,
				businessId: this.businessId,
				glId: this.bigTeamSel.value.id,
				hqId: this.mediumTeamSel.value.id,
				teamId: this.smallTeamSel.value.id,
				blocked_or: this.approvalReturn(),
				search_name: this.namePhoneSel.value === '이름' ? this.search_project : '',
				search_phone: this.namePhoneSel.value === '연락처' ? this.search_project : '',
			}
			if (this.authoritySel.value !== 'all') {
				filtered.role = this.authoritySel.value
			}
			// 마케터 데이터 가져오기
			await this.$store.dispatch('userAllList', filtered).then(res => {
				// 가져온 데이터 테이블에 적용
				if (Array.isArray(res.data.userAllList)) {
					const dataArr = []

					const startIndex = range.start ? range.start : 0
					for (let i = 0; i < res.data.userAllList.length; i++) {
						const el = res.data.userAllList[i]
						// 가져온 데이터를 기준에 맞게 변환 후 적용
						const { glTitle, hqTitle, teamTitle, role: { name: roleName } = {}, recentLogin, approvalDate, blocked } = el

						let marketingCheck = ''
						if (this.table.datatable.selected_user && Array.isArray(this.table.datatable.selected_user)) {
							for (let j = 0; j < this.table.datatable.selected_user.length; j++) {
								if (this.table.datatable.selected_user[j] === res.data.userAllList[i].id) {
									marketingCheck = res.data.userAllList[i].id
									break
								}
							}
						}

						const obj = {
							...el,
							marketingCheck: marketingCheck,
							index: String(i + 1 + startIndex),
							glTitle: glTitle || '미배정',
							hqTitle: hqTitle || '미배정',
							teamTitle: teamTitle || '미배정',
							role: this.$gf.convertRole(roleName) ? this.$gf.convertRole(roleName) : '미배정',
							recentLogin: recentLogin ? this.$moment(recentLogin).format('YYYY-MM-DD HH:mm') : '-',
							approvalDate: approvalDate ? this.$moment(approvalDate).format('YYYY-MM-DD HH:mm') : '-',
							approval: !blocked,
							distribution: this.$gf.convertCurrency(el.distribution),
							processed: this.$gf.convertCurrency(el.processed),
							unprocessesd: this.$gf.convertCurrency(el.unprocessesd),
						}

						dataArr.push(obj)
					}

					let newTable = {}

					newTable = {
						datatable: {
							headers: this.table.datatable.headers,
							items: dataArr,
							hidedefaultfooter: false,
							noweditting: '',
							onlyAgree: false,
							// showselect: true,
							total: res.data.userAllListCount.count ? res.data.userAllListCount.count : 0,
							page: range ? range.page : 1,
							itemPerPage: range.itemPerPage ? range.itemPerPage : 10,
							selected_user: [],
							pagination:
								range.page && range.itemPerPage
									? {
											page: range.page,
											itemsPerPage: range.itemPerPage,
									  }
									: {
											page: 1,
											itemsPerPage: 10,
									  },
						},
					}

					this.table = newTable
				}

				this.$store.state.loading = false
			})

			// 검색 텍스트필드 blur 처리
			this.$refs.search_input.$children[0].$refs.input.blur()
			this.table.datatable.headers[0].checked = false
		},

		/**비즈니스 모델 리스트를 불러와 카테고리 적용
		@author 임호진
		*/
		async getMarketerList() {
			this.$store.state.loading = true
			// 비즈니스 카테고리 리스트 불러오기
			await this.$store.dispatch('bizTitle').then(async resData => {
				if (resData.data.bizTitle.businesses.length > 0) {
					this.marketerCategory.items = resData.data.bizTitle.businesses

					this.marketerCategory.value = resData.data.bizTitle.businesses[0]
					this.businessId = resData.data.bizTitle.businesses[0].id

					this.$store.state.loading = false

					await this.getGroupList('gl', false)
				} else this.$store.state.loading = false
			})

			this.$store.state.loading = false
		},
		// 데이터 테이블 - 자세히보기 클릭
		detailClick(item) {
			this.clicked_data = item
			this.marketerManage_dialog.dialog = true
		},
		// 페이지네이션 처리
		async pagination(item) {
			if (!this.table.datatable.pagination) {
				this.table.datatable['pagination'] = item
				this.table.datatable.options = item
			}
			if (item.page > this.table.datatable.pagination.page) {
				// 다음 페이지
				let range = {
					start: (item.page - 1) * item.itemsPerPage,
					limit: item.itemsPerPage,
					itemPerPage: item.itemsPerPage,
					page: item.page,
				}
				await this.getTableData(range)
			} else if (item.itemsPerPage !== this.table.datatable.pagination.itemsPerPage) {
				// 한페이지에 보여줄 아이템 개수 변경

				let range = {
					start: 0,
					limit: item.itemsPerPage,
					itemPerPage: item.itemsPerPage,
					page: 1,
				}
				await this.getTableData(range)
			} else if (item.page < this.table.datatable.pagination.page) {
				// 이전 페이지

				let range = {
					start: (item.page - 1) * item.itemsPerPage,
					limit: item.itemsPerPage,
					itemPerPage: item.itemsPerPage,
					page: item.page,
				}
				await this.getTableData(range)
			}
			this.table.datatable['pagination'] = JSON.parse(JSON.stringify(item))
		},

		// 엑셀파일 다운로드
		async getExcelData() {
			this.$store.state.loading = true

			const filter = {
				businessId: this.businessId,
				glId: this.bigTeamSel.value.id,
				hqId: this.mediumTeamSel.value.id,
				teamId: this.smallTeamSel.value.id,
				blocked_or: this.approvalReturn(),
				search_name: this.namePhoneSel.value == '이름' ? this.search_project : '',
				search_phone: this.namePhoneSel.value == '연락처' ? this.search_project : '',
				role: this.authoritySel.value == 'all' ? undefined : this.authoritySel.value,
				_limit: 100000,
			}
			let excel_data
			await this.$store.dispatch('userAllList', filter).then(res => {
				excel_data = res.data.userAllList

				if (Array.isArray(excel_data) && excel_data.length > 0) {
					for (let index = 0; index < excel_data.length; index++) {
						const marketingDb = excel_data[index]

						marketingDb['created_at_time'] = !marketingDb.created_at ? '-' : this.$moment(marketingDb.created_at).format('YYYY-MM-DD HH:mm')
						marketingDb['role'] = !this.$gf.convertRole(marketingDb['role']['name'])
							? '미배정'
							: this.$gf.convertRole(marketingDb['role']['name'])
						marketingDb['recentLogin'] = !marketingDb.recentLogin ? '-' : this.$moment(marketingDb.recentLogin).format('YYYY-MM-DD HH:mm')
						marketingDb['approvalDate'] = !marketingDb.approvalDate
							? '-'
							: this.$moment(marketingDb.approvalDate).format('YYYY-MM-DD HH:mm')
						marketingDb['approval'] = marketingDb.blocked ? '미승인' : '승인'
						marketingDb['phone'] = marketingDb.phone.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`)

						marketingDb['glTitle'] = marketingDb['glTitle'] ? marketingDb['glTitle'] : '미배정'
						marketingDb['hqTitle'] = marketingDb['hqTitle'] ? marketingDb['hqTitle'] : '미배정'
						marketingDb['teamTitle'] = marketingDb['teamTitle'] ? marketingDb['teamTitle'] : '미배정'

						marketingDb['index'] = String(index + 1)
					}
				}
			})
			this.$store.state.loading = false
			this.excelArr = []
			return excel_data
		},

		// 마케터 그룹 다이얼로그 띄우기
		openGropManage() {
			this.marketerGroup_dialog.dialog = true
		},

		/**** 승인/미승인 셀렉트 박스 변경
 @author 전현균
 */
		changeApproval() {
			this.initSearch()
			this.getTableData()
		},

		/**** 승인/미승인 셀렉트 박스 값에 따라 blocekd_or 데이터 리턴
blocked = null || blocked = false 인 유저가 승인 이라  query or 처리를 위한 데이터 세팅
필터값 = all =>  undefined
필터값 = 승인 =>  [{ blocked: false }, { blocked_null: true }]
필터값 = 미승인 =>  [{ blocked: true }]
 @author 전현균
 */
		approvalReturn() {
			if (this.approveSel.value === 'all') {
				return undefined
			} else if (!this.approveSel.value) {
				const blocked_or = [{ blocked: false }, { blocked_null: true }]

				return blocked_or
			} else {
				const blocked_or = [{ blocked: true }]
				return blocked_or
			}
		},
		/**** 헤더에서 일괄승인 버튼 클릭
상담사 숫자, 미승인 상담사 숫자에 따라 팝업 분기 처리
 @author 전현균
 */
		async clickAllapproval(type) {
			this.$store.state.loading = true

			const exist_vriable = {
				// 등록된 상담사 카운트 변수
				businessId: this.businessId,
			}
			const existYn = await this.userAllListCount(exist_vriable) // 등록된 상담사 카운트

			if (existYn === 'error') {
				this.sweetDialog.title = '네트워크 에러'
				this.sweetDialog.modalIcon = 'info'
				this.sweetDialog.content = '네트워크 에러가 발생했습니다 \n 잠시 후 다시 시도해주시기 바랍니다.'
				this.sweetDialog.open = true
				return
			} else if (existYn === 0) {
				// 등록된 상담사 === 0 팝업
				this.sweetDialog.title = '상담사 미등록'
				this.sweetDialog.modalIcon = 'info'
				this.sweetDialog.content = '등록된 상담사가 없습니다.'
				this.sweetDialog.open = true
				return
			} else {
				// 등록된 상담사 > 0 팝업
				const blocked_vriable = {
					// 미승인 상담사 카운트 변수
					businessId: this.businessId,
					blocked: true,
				}
				this.blocked_count = await this.userAllListCount(blocked_vriable) // 미승인 상담사 카운트
				this.approval_count = existYn - this.blocked_count // 승인 상담사 카운트

				if (this.blocked_count === 'error') {
					this.sweetDialog.title = '네트워크 에러'
					this.sweetDialog.modalIcon = 'info'
					this.sweetDialog.content = '네트워크 에러가 발생했습니다 \n 잠시 후 다시 시도해주시기 바랍니다.'
					this.sweetDialog.open = true
				} else if (this.table.datatable.selected_user.length === 0) {
					this.sweetDialog.title = '상담사 선택 필수'
					this.sweetDialog.modalIcon = 'info'
					this.sweetDialog.content = '상담사를 선택해 주세요'
					this.sweetDialog.open = true
				} else if (type === 'approve' && this.blocked_count === 0) {
					// 미승인 상담사 === 0 팝업
					this.sweetDialog.title = '모든 상담사 승인'
					this.sweetDialog.modalIcon = 'info'
					this.sweetDialog.content = '모든 상담사가 이미 승인 상태입니다'
					this.sweetDialog.open = true
				} else if (type === 'disApprove' && this.approval_count === 0) {
					// 승인 상담사 === 0 팝업
					this.sweetDialog.title = '모든 상담사 미승인'
					this.sweetDialog.modalIcon = 'info'
					this.sweetDialog.content = '모든 상담사가 이미 미승인 상태입니다'
					this.sweetDialog.open = true
				} else {
					// 미승인 상담사 > 0 => 일광승인 확인 팝업
					if (type === 'approve') {
						this.sweet_allApprove.open = true
					} else if (type === 'disApprove') {
						this.sweet_allDisApprove.open = true
					}
				}
			}

			this.$store.state.loading = false
		},

		/**** 변수별로 상담사 숫자 카운트
businessId / blocked 필터 추가하여 상담사 필터하여 카운트 가능
//  @author 전현균
 */
		async userAllListCount(variable) {
			const response = await this.$store
				.dispatch('userAllListCount', variable)
				.then(async res => {
					const blockedCount = res.data.userAllListCount.count
					return blockedCount
				})
				.catch(() => {
					return 'error'
				})

			return response
		},
		/**전체 체크 or 전체 해제
		@param {string} type header , item
		@author 노의진
		*/
		marketingAllCheck(type) {
			if (type === 'header') {
				if (this.table.datatable.headers[0].checked) {
					this.table.datatable.selected_user = this.table.datatable.items.map(el => el.id)
				} else {
					this.table.datatable.selected_user = []
				}
			} else {
				this.table.datatable.headers[0].checked = this.table.datatable.selected_user.length === this.table.datatable.items.length
			}
		},

		/**** 일괄승인 얼러트에서 확인 클릭
모든 미승인된 마케터들을 승인 처리
 @author 전현균
 @returns  승인이면 리턴 
*/
		async approveAll() {
			this.sweet_allApprove.open = false
			this.$store.state.loading = true

			if (this.table.datatable.selected_user && Array.isArray(this.table.datatable.selected_user)) {
				const blockedValues = this.table.datatable.items
					.filter(el => this.table.datatable.selected_user.includes(el.id))
					.map(el => el.blocked)

				for (let i = 0; i < blockedValues.length; i++) {
					if (blockedValues[i] === false) {
						this.sweetDialog.title = '승인 에러'
						this.sweetDialog.modalIcon = 'info'
						this.sweetDialog.content = `승인된 마케터가 존재 합니다.`
						this.sweetDialog.open = true
						return
					}
				}
			}

			const variable = {
				// 승인처리할 프로젝트 아이디 세팅
				users: this.table.datatable.selected_user,
				userId: String(this.$store.state.meData.id),
				blocked: false,
			}

			await this.$store
				.dispatch('approveAll', variable)
				.then(async res => {
					const result = res.data.approveAll.response.result
					let range = {
						start: (this.table.datatable.pagination.page - 1) * this.table.datatable.pagination.itemsPerPage,
						limit: this.table.datatable.pagination.itemsPerPage,
						itemPerPage: this.table.datatable.pagination.itemsPerPage,
						page: this.table.datatable.pagination.page,
					}
					await this.getTableData(range)
					if (result === 'success') {
						this.sweetDialog.title = '일괄승인 완료'
						this.sweetDialog.modalIcon = 'success'
						this.sweetDialog.content = `${variable.users.length}건 승인 완료하였습니다.`
						this.sweetDialog.open = true
					}
				})
				.catch(() => {
					this.sweetDialog.title = '네트워크 에러'
					this.sweetDialog.modalIcon = 'info'
					this.sweetDialog.content = '네트워크 에러가 발생했습니다 \n 잠시 후 다시 시도해주시기 바랍니다.'
					this.sweetDialog.open = true
				})
			this.table.datatable.headers[0].checked = false
			this.$store.state.loading = false
		},
		/**** 승인 => 미승인 변경
		 * 체크된 미승인 얼러트에서 확인 클릭 후 변경
@author 노의진
@returns  미승인이면 리턴 
*/
		async disApproveAll() {
			this.sweet_allDisApprove.open = false
			this.$store.state.loading = true
			if (this.table.datatable.selected_user && Array.isArray(this.table.datatable.selected_user)) {
				const blockedValues = this.table.datatable.items
					.filter(el => this.table.datatable.selected_user.includes(el.id))
					.map(el => el.blocked)

				for (let i = 0; i < blockedValues.length; i++) {
					if (blockedValues[i] === true) {
						this.sweetDialog.title = '승인 에러'
						this.sweetDialog.modalIcon = 'info'
						this.sweetDialog.content = `미승인된 마케터가 존재 합니다.`
						this.sweetDialog.open = true
						return
					}
				}
			}
			const variable = {
				users: this.table.datatable.selected_user,
				userId: String(this.$store.state.meData.id),
				blocked: true,
			}
			await this.$store
				.dispatch('approveAll', variable)
				.then(async res => {
					const result = res.data.approveAll.response.result

					let range = {
						start: (this.table.datatable.pagination.page - 1) * this.table.datatable.pagination.itemsPerPage,
						limit: this.table.datatable.pagination.itemsPerPage,
						itemPerPage: this.table.datatable.pagination.itemsPerPage,
						page: this.table.datatable.pagination.page,
					}
					await this.getTableData(range)
					if (result === 'success') {
						this.sweetDialog.title = '일괄 미승인 완료'
						this.sweetDialog.modalIcon = 'success'
						this.sweetDialog.content = `${variable.users.length}건 미승인 완료하였습니다.`
						this.sweetDialog.open = true
					}
				})
				.catch(() => {
					this.sweetDialog.title = '네트워크 에러'
					this.sweetDialog.modalIcon = 'info'
					this.sweetDialog.content = '네트워크 에러가 발생했습니다 \n 잠시 후 다시 시도해주시기 바랍니다.'
					this.sweetDialog.open = true
				})
			this.table.datatable.headers[0].checked = false
			this.$store.state.loading = false
		},
		/**** 스위치 버튼으로 마케터별 승인 처리
미승인으로 바꾸는 경우에는 배분된 건수가 없을 경우 바로 미승인처리
배분된 건수 있을 경우 미승인 확인 팝업 열기
 @author 전현균
 */
		async approveIndividual(item) {
			if (item.approval || (!item.approval && item.distribution === 0)) {
				// 미승인-> 승인 또는 승인->미승인이지만 배분 건수 0 인 경우
				this.$store.state.loading = true

				const variable = {
					// 승인처리할 마케터 아이디 세팅
					id: item.id,
					userId: String(this.$store.state.meData.id),
				}

				await this.$store
					.dispatch('approveIndividual', variable)
					.then(res => {
						const result = res.data.approveIndividual.response.blocked
						if (result) {
							this.sweetDialog.title = '미승인 처리'
							this.sweetDialog.modalIcon = 'success'
							this.sweetDialog.content = `미승인 처리하였습니다.`
							this.sweetDialog.open = true
							item.approvalDate = '-'
						} else {
							this.sweetDialog.title = '승인 처리'
							this.sweetDialog.modalIcon = 'success'
							this.sweetDialog.content = `승인 처리하였습니다.`
							this.sweetDialog.open = true
							item.approvalDate = this.$moment().format('YYYY-MM-DD HH:mm')
						}
					})
					.catch(() => {
						this.sweetDialog.title = '네트워크 에러'
						this.sweetDialog.modalIcon = 'info'
						this.sweetDialog.content = '네트워크 에러가 발생했습니다 \n 잠시 후 다시 시도해주시기 바랍니다.'
						this.sweetDialog.open = true
					})
				this.$store.state.loading = false
			} else {
				// 승인 -> 미승인 이면서 배분된 건수가 1건 이상인 경우 미승인 확인 팝업 열기
				this.sweet_unapproved.open = true
				this.sweet_unapproved.content = `미승인 처리 시 마케터에 배분된\n고객 ${item.distribution}건이 회수됩니다.`
				this.sweet_unapproved.item = item
			}
		},

		/**** 개인 미승인 처리 확인 버튼 클릭
배분된 건수 회수 처리 및 미승인 처리
 @author 전현균
 */
		async unapproveIndividual() {
			this.$store.state.loading = true
			const variable = {
				// 미승인 처리할 마케터 아이디 세팅
				id: this.sweet_unapproved.item.id,
				userId: String(this.$store.state.meData.id),
			}
			await this.$store
				.dispatch('approveIndividual', variable)
				.then(() => {
					this.sweet_unapproved.open = false

					this.sweet_unapproved.item.distribution = 0
					this.sweet_unapproved.item.processed = 0
					this.sweet_unapproved.item.unprocessesd = 0
					this.sweet_unapproved.item.approvalDate = '-'

					this.sweetDialog.title = '미승인 처리'
					this.sweetDialog.modalIcon = 'success'
					this.sweetDialog.content = `미승인 처리하였습니다.`
					this.sweetDialog.open = true
				})
				.catch(() => {
					this.sweetDialog.title = '네트워크 에러'
					this.sweetDialog.modalIcon = 'info'
					this.sweetDialog.content = '네트워크 에러가 발생했습니다 \n 잠시 후 다시 시도해주시기 바랍니다.'
					this.sweetDialog.open = true
				})
			this.$store.state.loading = false
		},

		/**** 미승인 확인 팝업 취소 클릭시 상담사 원래대로 복원
 @author 전현균
 */
		unapproveIndividualCancel() {
			this.sweet_unapproved.item.approval = true
		},

		/****마케팅 그룹 관리 팝업에서 생성/삭제 등의 행위가 있었을 경우
총괄 / 본부 / 팀 의 각 앞에 있는 셀렉트박스의 값이 있는 경우 재호출 하여 item 세팅 
 @author 전현균 
 */
		async marketerGroupChange() {
			this.$store.state.loading = true

			await this.getGroupList('gl', false)
			if (this.bigTeamSel.value && this.bigTeamSel.value !== '전체') {
				await this.getGroupList('hq', false)
			}
			if (this.mediumTeamSel.value && this.mediumTeamSel.value !== '전체') {
				await this.getGroupList('team', false)
			}

			const pagination_data = this.table.datatable.pagination
			const range = {
				start: (pagination_data.page - 1) * pagination_data.itemsPerPage,
				limit: pagination_data.itemsPerPage,
				itemPerPage: pagination_data.itemsPerPage,
				page: pagination_data.page,
			}
			await this.getTableData(range)

			this.$store.state.loading = false
		},
	},
}
</script>
<style lang="scss" scoped>
.wrapper {
	margin: 0px !important;
}
</style>
<style lang="scss">
.surveyChoice {
	font-size: 18px;
	font-weight: bold;
	margin-right: 10px;
}

.surveyTitle {
	font-size: 18px;
	font-weight: bold;
	margin-top: 20px;
}

.filterFlex {
	padding: 20px 20px 58px 0px;
}

.filterBox {
	background: white;
	height: 100%;
	border: 2px solid #e1e1e1;
	border-radius: 5px;
}

.filterHead {
	margin: 0px !important;
	padding: 14px;
	border-bottom: 1.5px solid #e1e1e1;
}

.filterLayout {
	padding: 14.8px;
	// border-bottom: 1.5px solid #e1e1e1;`
}

.checkboxLinebreak {
	line-break: anywhere;
}

.qaLists-dialog {
	opacity: 0;
	width: 100%;
	background-color: white !important;
}

.search_box_type {
	width: auto !important;
	height: 26px !important;
	margin-right: 10px !important;
	padding: 0 10px !important;
	font-size: 13px;
	font-weight: bold;

	.v-btn__content {
		color: #fff;
	}
}

//검색 박스
.search_box_type {
	width: 193px;
	margin-left: 10px;

	div {
		div {
			.v-input__slot {
				min-height: 26px !important;
				height: 26px;
				padding: 0 10px !important;
			}
		}
	}
}

.search_select_type {
	min-height: 26px !important;
	height: 26px !important;
	width: 400px;
	max-width: 400px;

	div {
		div {
			div {
				div {
					.v-input__append-inner {
						margin-top: 1px !important;
					}
				}
			}
		}
	}
}

.customer-management-text {
	font-size: 12px;
	font-weight: bold;
	width: auto;
	color: #204037;
}

.customer-management-btn {
	box-shadow: none;
	border: 1px solid #c5c3d5;
	width: 88px;
	height: 26px !important;
	background-color: #f3f3ff !important;

	.v-btn__content {
		color: #323153;
		font-size: 13px;
	}
}
</style>
